export default __webpack_public_path__ + "static/media/create_workspace.76a247b9.png";